
let filters = [];
filters = Array.from( retailCategoriesDetails.categorytiles.reduce((map, tile) => {
  if(tile.Icon && tile.category && !map.has(tile.category)) {
    const card =  {
      name: tile.category,
      icon:  tile.category,
      src: tile.Icon
    }
    map.set(card.name, card);
  }
    return map;
  }, new Map()).values()
);

const filterContent = filters;

export default filterContent;
